<template>
    <!-- 使用 van-button，绑定所有需要传入的 props 和合并后的样式，点击事件向上传递 -->
    <van-button v-bind="buttonProps" :style="mergedStyle" @click="$emit('click')">
        <slot />
    </van-button>
</template>

<script>
export default {
    name: 'TianshengButton',
    props: {
        // 按钮类型，例如 primary、default 等
        type: { type: String, default: 'default' },
        // 按钮大小，例如 small、normal、large
        size: { type: String, default: 'normal' },
        // 按钮显示的文本
        text: String,
        // 按钮背景颜色
        color: String,
        // 图标名称
        icon: String,
        // 图标类名前缀
        iconPrefix: String,
        // 图标位置，left 或 right
        iconPosition: { type: String, default: 'left' },
        // 标签类型，默认是 button
        tag: { type: String, default: 'button' },
        // 原生 type 属性，例如 submit/reset/button
        nativeType: String,
        // 是否为块级元素
        block: { type: Boolean, default: false },
        // 是否为朴素按钮（无背景）
        plain: { type: Boolean, default: false },
        // 是否为方形按钮
        square: { type: Boolean, default: false },
        // 是否为圆形按钮
        round: { type: Boolean, default: false },
        // 是否禁用按钮
        disabled: { type: Boolean, default: false },
        // 是否使用细边框
        hairline: { type: Boolean, default: false },
        // 是否为加载状态
        loading: { type: Boolean, default: false },
        // 加载时显示的文本
        loadingText: String,
        // 加载动画类型（spinner 或 circular）
        loadingType: { type: String, default: 'circular' },
        // 加载动画大小
        loadingSize: { type: String, default: '' },
        // 按钮字体大小
        fontSize: { type: String, default: '16px' },
        // 按钮字体粗细
        fontWeight: { type: String, default: '' },
        // 按钮圆角
        borderRadius: { type: String, default: '' },
        // 点击跳转的链接
        url: String,
        // Vue Router 的跳转对象
        to: [String, Object],
        // 新增：字体颜色
        fontColor: { type: String, default: '' },
        // 新增：传入自定义的 style 样式对象
        customStyle: { type: Object, default: () => ({}) }
    },
    computed: {
        // 生成传给 van-button 的 props 对象
        buttonProps() {
            const {
                type, size, text, color, icon, iconPrefix, iconPosition, tag,
                nativeType, block, plain, square, round, disabled, hairline,
                loading, loadingText, loadingType, loadingSize, fontSize, url, to
            } = this;

            return {
                type,
                size,
                color,
                icon,
                'icon-prefix': iconPrefix,
                'icon-position': iconPosition,
                tag,
                'native-type': nativeType,
                block,
                plain,
                square,
                round,
                disabled,
                hairline,
                loading,
                'loading-text': loadingText || text,
                'loading-type': loadingType,
                'loading-size': loadingSize || fontSize,
                url,
                to,
                text,
            };
        },

        // 合并样式，优先使用传入的 fontColor 和 customStyle
        mergedStyle() {
            return {
                // 默认颜色定义，可被 fontColor/customStyle 覆盖
                color: 'var(--main-color)',
                background: 'var(--main-bgcolor)',
                border: 'var(--main-border)',
                fontSize: this.fontSize,
                fontWeight: this.fontWeight,
                borderRadius: this.borderRadius,
                // 如果有传入字体颜色则覆盖默认
                ...(this.fontColor ? { color: this.fontColor } : {}),
                // 合并用户传入的自定义样式
                ...this.customStyle
            };
        }
    }
};
</script>

<style lang="scss">
@import "./index.scss"; // 引入按钮样式文件
</style>
